"use strict";
/**
 * Created on 10 15 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * <p>Serialization/deserialization of {@link ExportedPriceWithValidity}.</p>
 *
 * @author JMe
 */


var ExportedPriceWithValidityConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(ExportedPriceWithValidityConverter, _DataObjectConverter_);

  function ExportedPriceWithValidityConverter() {
    _classCallCheck(this, ExportedPriceWithValidityConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ExportedPriceWithValidityConverter).apply(this, arguments));
  }

  return ExportedPriceWithValidityConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.ExportedPriceWithValidityConverter = ExportedPriceWithValidityConverter;